import camelCase from 'lodash.camelcase';
import axios from 'axios';
import Config from '@/rearchitected/core/js/ddriven/application/config/Config';

const TTL = 5 * 60 * 1000;

const globalDictionariesModule = {
    namespaced: true,
    state: {
        blockRequestStatuses: [],
        budgetaryManagers: [],
        deliverableGroups: [],
        fl44ProposalStatuses: [],
        fl44PurchaseDurationTypes: [],
        fl44UnknownVolumePurchaseDurationTypes: [],
        municipalities: [],
        orderTypes: [],
        purchaseStatuses: [],
        fl44SupplementaryAgreementTypes: [],
        fl44ContractTerminationTypes: [],
        offerDeclineStatuses: [],
        vat: [],
        updatedAt: null,
        isUpdating: false
    },
    mutations: {
        set(state, data) {
            for (const key in data) {
                const stateKey = camelCase(key);
                if (stateKey in state) {
                    state[stateKey] = data[key];
                }
            }
            state['updatedAt'] = new Date();
        },
        globalDictionariesStartedUpdating(state) {
            state.isUpdating = true;
        },
        globalDictionariesFinishedUpdating(state) {
            state.isUpdating = false;
        }
    },
    actions: {
        async populateGlobalDictionaries(context) {
            if (context.state.isUpdating === true) {
                return;
            }
            context.commit('globalDictionariesStartedUpdating');
            if (context.state.updatedAt === null || new Date() - new Date(context.state.updatedAt).getTime() > TTL) {
                const globalDictionariesResponse = await axios.post(Config.get('api.config.v1.url') + '/dictionaries');
                context.commit('set', globalDictionariesResponse.data?.data);
            }
            context.commit('globalDictionariesFinishedUpdating');
        }
    },
    getters: {
        globalDictionaries(state) {
            return {
                blockRequestStatuses: state.blockRequestStatuses,
                budgetaryManagers: state.budgetaryManagers,
                deliverableGroups: state.deliverableGroups,
                fl44ProposalStatuses: state.fl44ProposalStatuses,
                fl44PurchaseDurationTypes: state.fl44PurchaseDurationTypes,
                fl44UnknownVolumePurchaseDurationTypes: state.fl44UnknownVolumePurchaseDurationTypes,
                municipalities: state.municipalities,
                orderTypes: state.orderTypes,
                orderTypesWithLimits: state.orderTypes.filter((item) => item.is_limits_used),
                purchaseStatuses: state.purchaseStatuses,
                fl44SupplementaryAgreementTypes: state.fl44SupplementaryAgreementTypes,
                fl44ContractTerminationTypes: state.fl44ContractTerminationTypes,
                offerDeclineStatuses: state.offerDeclineStatuses,
                vat: state.vat
            };
        }
    }
};

export default globalDictionariesModule;
